import { useEffect, useState } from "react";
import { NewCarBookingSuccessResponse, RentalPrice } from "../api/types";
import api from "./../api/api";
import { SelectOption, SelectOptionGroup } from "./ui/Select";

const useConnect = () => {
  const [rentalPlaces, setRentalPlaces] = useState<SelectOptionGroup[]>([]);
  const [prices, setPrices] = useState<RentalPrice[]>([]);
  const [offer, setOffer] = useState<RentalPrice>();
  const [pickupPlace, setPickupPlace] = useState<SelectOption>();
  const [booking, setBooking] = useState<NewCarBookingSuccessResponse>();
  const [rentalDates, setRentalDates] = useState<Date[]>();

  useEffect(() => {
    async function loadPlaces() {
      const response = await api.getPickupPlaces();

      if (response?.status === 200) {
        const pickupPlaces = response.data.map(function (x) {
          return {
            group: x.province,
            items: x.locations.map((y) => {
              return {
                name: y.name,
                value: y.code,
              };
            }),
          };
        });

        setRentalPlaces(pickupPlaces);
      }
    }

    loadPlaces();
  }, []);

  return {
    rentalPlaces,
    prices,
    setPrices,
    offer,
    setOffer,
    pickupPlace,
    setPickupPlace,
    booking,
    setBooking,
    rentalDates,
    setRentalDates,
  };
};
export default useConnect;
